<template>
  <div class="my_collect">
    <div class="tabs" style="margin:0 25px;font-size:16px;">
      <div v-for="item in collectTypeList"
           :key="item.key"
           :class="'tab-item '+(item.key===collectType?'tab-item-active':'')"
           @click="changeStatusHandle(item.key)">
        {{item.lable}}
      </div>
    </div>
    <div class="goodList" v-loading="loading">
      <el-row :gutter="20" v-show="goodList.length && collectType === 'Good'">
        <el-col :span="6" v-for="item in goodList" :key="item.spuId">
          <div class="good-item">
            <img :src="item.fileUrl"
                class="cursor-pointer good-img"
                alt=""
                width="190px"
                height="190px"
                @click="goDetail(item)">
            <div class="price price_text" v-show="item.commodityType && item.commodityType.indexOf('非标') > -1 || item.isSellingPriceExpire">待询价</div>
            <good-price v-show="item.commodityType && item.commodityType.indexOf('非标') === -1 && !item.isSellingPriceExpire" :price="Number(item.sellingPrice) || 0"></good-price>
            <!-- <good-price :price="Number(item.sellingPrice) || 0"></good-price> -->
            <div class="multi_line_overflow good-spu-name line-break">{{item.title}}</div>
            <!-- <div class="spu-code">订货编号：{{item.supplyCommodityCode}}</div> -->
            <div
              class="add_cart"
              :loading="item.loading"
              @click.stop="addCart(item, $event)"
            >
              <div class="add_cart_icon">
                <img src="~@/assets/img/good/addCart.png" class="add_cart_icon_animate" alt="" />
              </div>
              <span class="add_cart_text" v-if="item.commodityType &&
              item.commodityType.indexOf('非标') === -1 &&
              !item.isSellingPriceExpire">加入购物车</span>
              <span class="add_cart_text" v-else>加入询价篮</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="goodList.length && (collectType === 'Files' || collectType === 'Videos')">
        <div class="post-list" v-if="goodList&&goodList.length">
          <div class="post-info" v-for="item in goodList" :key="item.id">
            <div class="post-info-img" @click="routerHandle(item)">
              <img :src="item.userAvatarURL" width="74px" height="74px" :alt="item.userNickname"/>
            </div>
            <div class="post-detail" @click="routerHandle(item)">
              <div class="post-detail-title overell">{{item.title}}</div>
              <div class="post-detail-content">{{item.discribe}}</div>
              <div class="post-detail-time">
                <span style="margin-right: 10px" v-if="item.userNickname">{{item.userNickname}}</span>
                <span>{{item.createTime}}</span>
              </div>
            </div>
            <div class="post-status" @click="cancleCollect(item)">取消收藏</div>
          </div>
        </div>
      </el-row>
      <el-row :gutter="20" v-show="goodList.length && (collectType === 'Solution' || collectType === 'Serive')">
        <el-col :span="6" v-for="item in goodList" :key="item.spuId">
          <div class="good-item plan-item">
            <img :src="item.solutionUrl||item.serviceUrl"
                class="cursor-pointer good-img"
                alt=""
                width="190px"
                height="190px"
                @click="goSoluServviceDetail(item)">
            <!-- <good-price :price="Number(item.sellingPrice) || 0"></good-price> -->
            <div class="ellipsis plan-name line-break">{{item.solutionName || item.serviceName}}</div>
            <!-- <div class="spu-code">订货编号：{{item.supplyCommodityCode}}</div> -->
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="goodList.length && (collectType === 'TrainCourse')">
        <div class="post-list" v-if="goodList&&goodList.length">
          <div class="post-info" v-for="item in goodList" :key="item.id">
            <div class="post-info-img train-course-img" @click="routerHandle(item)">
              <img :src="item.courseUrl" width="74px" height="74px" :alt="item.courseSubName"/>
            </div>
            <div class="post-detail" @click="routerHandle(item)">
              <div class="post-detail-title overell">{{item.title}}</div>
              <div class="post-detail-content">{{item.discribe}}</div>
              <div class="post-detail-time">
                <span>{{item.createTime}}</span>
              </div>
            </div>
            <div class="post-status" @click="cancleCollect(item)">取消收藏</div>
          </div>
        </div>
      </el-row>
      <el-pagination :current-page="currentPage"
                    :page-size="limit"
                    :key="`${currentPage}-${collectType}`"
                    :total="total"
                    v-show="total"
                    layout="total, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="getDataList">
      </el-pagination>
    </div>
    <div class="no_show_message" v-show="goodList.length=== 0">
      <img src="@/assets/img/good/noGood.png" alt="暂无相关收藏">
      <div>暂无相关收藏</div>
    </div>
  </div>
</template>
<script>
// import GoodList from '@/views/modules/good/goodList'
import GoodPrice from '@/components/good-price'
import { openOther } from '@/utils'
import { getAccessToken } from '@/utils/userInfo'
import anime from 'animejs'
export default {
  data () {
    return {
      loading: false,
      collectTypeList: [
        /* {
          key: 'Files',
          lable: '文档'
        }, {
          key: 'Videos',
          lable: '视频'
        }, */{
          key: 'Good',
          lable: '商品'
        }, {
          key: 'Solution',
          lable: '解决方案'
        }/*, {
          key: 'Serive',
          lable: '服务咨询'
        }, {
          key: 'TrainCourse',
          lable: '课程'
        } */
      ],
      collectType: 'Good',
      goodList: [],
      total: 0,
      limit: 12,
      currentPage: 1
    }
  },
  components: {
    GoodPrice
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    // 更改当前订单查询状态
    changeStatusHandle (valueKey) {
      if (valueKey === this.collectType) {
        return false
      }
      this.collectType = valueKey
      this.getDataList(1)
    },
    // 获取详情页面
    getDataList (page = this.currentPage) {
      this.currentPage = page
      this.total = 0
      if (this.collectType) {
        this.loading = true
        this['get' + this.collectType + 'List']()
      }
    },
    routerHandle (item) {
      if (this.collectType === 'Videos') {
        // track.clickVideoDetail(item.videoTitle)
        this.$router.push({
          name: 'knowledgevideoDetil',
          query: {
            videoId: item.collectionId
          }
        })
      } else if (this.collectType === 'Files') {
        // track.clickDocDetail(item.fileTitle)
        this.$router.push({
          name: 'bookDocDetail',
          query: {
            fileId: item.collectionId
          }
        })
      } else if (this.collectType === 'TrainCourse') {
        this.$router.push({
          name: 'courseDetail',
          query: {
            id: item.collectionId
          }
        })
      }
    },
    // 取消收藏
    cancleCollect (item) {
      let collectionType = this.collectType === 'Files' ? 'FILE' : 'VIDEO'
      if (this.collectType === 'TrainCourse') {
        collectionType = 'TrainCourse'
      }
      this.$http.post(`/front/kc/userInfo/usercollectioninfo/cancelUserCollect`, {
        collectionType: collectionType,
        collectionDataId: item.collectionId
      })
        .then(({ data }) => {
          this['get' + this.collectType + 'List']()
          this.$message.success('取消收藏成功')
        })
        .catch(() => {
        })
    },
    // 获取文档收藏
    getFilesList () {
      this.$http.post(`/front/kc/userInfo/usercollectioninfo/myCollectionFile`, {
        limit: this.limit,
        page: this.currentPage
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            return false
          }
          this.goodList = res.data.data || []
          this.total = res.data.count || 0
        })
        .catch(() => {
          this.goodList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取视频收藏
    getVideosList () {
      this.$http.post(`/front/kc/userInfo/usercollectioninfo/myCollectionVideo`, {
        limit: this.limit,
        page: this.currentPage
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            return false
          }
          this.goodList = res.data.data || []
          this.total = res.data.count || 0
        })
        .catch(() => {
          this.goodList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取商品收藏
    getGoodList () {
      this.$http.post(`/front/commodity-user/app/collection-list`, {
        limit: this.limit,
        page: this.currentPage
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            return false
          }
          this.goodList = res.data.dataList || []
          this.total = res.data.count || 0
          this.currentPage = res.data.currentPage
        })
        .catch(() => {
          this.goodList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取课程收藏
    getTrainCourseList () {
      this.$http.post(`/front/kc/userInfo/usercollectioninfo/myCollectionTrainCourse`, {
        limit: this.limit,
        page: this.currentPage
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            return false
          }
          this.goodList = res.data.data || []
          this.total = res.data.count || 0
        })
        .catch(() => {
          this.goodList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取解决方案收藏
    getSolutionList () {
      this.$http.post(`/front/user/home/homePlanCollection/findCollectionList`, {
        collectionType: '20', // 收藏类型（10：服务，20：解决方案）
        limit: this.limit,
        page: this.currentPage
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            return false
          }
          this.goodList = res.data.data || []
          this.total = res.data.count || 0
          this.currentPage = res.data.currentPage
        })
        .catch(() => {
          this.goodList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取服务收藏
    getSeriveList () {
      this.$http.post(`/front/user/home/homePlanCollection/findCollectionList`, {
        collectionType: '10' // 收藏类型（10：服务，20：解决方案）
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.goodList = []
            return false
          }
          this.goodList = res.data.data || []
          this.total = res.data.count || 0
        })
        .catch(() => {
          this.goodList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 更改每页条数
    pageSizeChangeHandle (val) {
      this.limt = val
      this.getDataList(1)
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`goodDetail?spuId=${goods.spuId}&skuId=${goods.skuId}`)
    },
    // 去解决方案或服务
    goSoluServviceDetail (item) {
      if (item && item.solutionId) {
        // this.$router.push({ name: 'planContent',
        //   query: {
        //     id: item.solutionId
        //   }
        // })
        openOther(`planContent?id=${item.solutionId}`)
      } else if (item && item.serviceId) {
        this.$router.push({
          name: 'serviceContent',
          query: {
            id: item.serviceId
          }
        })
      }
    },
    // 加入购物车
    addCart (goods, event) {
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      const spuId = goods.spuId
      const skuId = goods.skuId
      const custspId = goods.custspId
      // 购物车类型 ==1 是商品购物车，==2 是询价篮
      let shoppingType = '1'
      if ((goods.commodityType &&
      goods.commodityType.indexOf('非标') > -1) ||
      goods.isSellingPriceExpire) {
        shoppingType = '2'
      }
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: custspId,
          skuId: skuId,
          goodsNum:  1
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.createDraftAnime(goods, event, shoppingType)
          this.$message.success('购物车添加成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: spuId,
          goodsSkuId: skuId,
          goodsNum: 1,
          shoppingType: shoppingType
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success(
            `${this.$t('product.add')} ${
              shoppingType === '1'
                ? this.$t('product.cart')
                : this.$t('product.blanket')
            } ${this.$t('product.success')}`
          )
          this.createDraftAnime(goods, event, shoppingType)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 创建动画效果
    createDraftAnime (item, event, shoppingType) {
      // shoppingType 购物车类型 ==1 是商品购物车，==2 是询价篮
      const fileUrl = item.fileUrl
      const goodImage = event.target.parentNode.querySelector('.good-img') ||
                        event.target.parentNode.parentNode.querySelector('.good-img') // 获取商品图片
      const cartIcon = document.getElementById('add_cart_nav') // 获取购物车图标
      const cartIcon1 = document.getElementById('add_inquiry_cart_nav') // 获取询价蓝图标
      // 获取商品图片和购物车的位置
      const startRect = goodImage.getBoundingClientRect()
      const endRect = shoppingType == 1 ? cartIcon.getBoundingClientRect() : cartIcon1.getBoundingClientRect()

      // 创建飞行元素
      const flyImage = document.createElement('img')
      flyImage.src = fileUrl
      flyImage.style.position = 'fixed'
      flyImage.style.width = '200px'
      flyImage.style.height = '200px'
      flyImage.style.left = `${startRect.left}px`
      flyImage.style.top = `${startRect.top}px`
      flyImage.style.zIndex = 9999
      document.body.appendChild(flyImage)

      // 使用 anime.js 实现飞行动画
      anime({
        targets: flyImage,
        left: `${endRect.left}px`,
        top: `${endRect.top}px`,
        width: '20px',
        height: '20px',
        duration: 1000,
        easing: 'easeInOutQuad',
        complete: () => {
          // 通知购物车
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )

          // 动画完成后移除飞行元素
          document.body.removeChild(flyImage)
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.my_collect{
  .tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active{
    color: #1D65A8;
    border-bottom: 2px solid #1D65A8;
  }
  .goodList{
    background: #fff;
    .good-item{
      margin-top: 3px;
      background: #fff;
      // height: 300px;
      height: 340px;
      padding: 20px 10px;
      .good-img{
        border: 1px solid #eee;
        margin: 0 auto;
      }
      &:hover{
        -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
        -moz-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
      }
      /deep/ .price {
        margin-top: 10px;
        color: #e64c3a;
        font-weight: bold;
        min-height: 30px;
        .price-int {
          font-size: 20px;
        }
        .price-point {
          font-size: 10px;
        }
      }
      .good-spu-name{
        height: 34px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
      }
      .spu-code{
        margin-top: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
      img{
        object-fit: contain;
      }

      .add_cart {
        margin-top: 5px;
        border-radius: 8px;
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        background: #2a54d1;
        height: 36px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .add_cart_icon {
          width: 18px;
          height: 18px;
          img {
            width: 100%;
            display: block;
          }
        }
        .add_cart_text {
          color: #ffffff;
          font-weight: 500;
          font-size: 16px;
          margin-left: 3px;
        }
      }
    }
    .plan-item{
      margin-top: 3px;
      background: #fff;
      height: 260px;
      padding: 20px 10px;
      border: 1px solid #eee;
      .plan-name{
        height: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
      }
    }
  }
  .post-list {
    margin: 0 79px;
  }
  .post-info{
    margin-top: 30px;
    width: 100%;
    display: flex;
    padding-bottom: 28px;
    border-bottom: 1px solid #eee;
  }
  .post-info-img{
    width: 74px;
    height: 74p;
    cursor: pointer;
  }
  .train-course-img img {
    object-fit: contain;
    border-radius: 0 !important;
  }
  .post-info-img img{
    width: 74px;
    height: 74p;
    border-radius: 37px;
    overflow: hidden;
  }
  .post-detail {
    width: 550px;
    margin-right: 20px;
    margin-left: 30px;
    cursor: pointer;
  }
  .post-detail-title{
    text-align: left;
    line-height: 22px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.6px;
    height: 22px;
    margin-bottom: 10px;
  }
  .post-detail-content{
    width: 531px;
    text-align: left;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.6px;
    height: 20px;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .post-detail-time{
    line-height: 17px;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0.6px;
  }
  .post-status{
    cursor: pointer;
    width: 105px;
    text-align: center;
    font-size: 14px;
    color: #1D65A8;
    padding:10px 21px;
    border: 1px solid #eee;
    height: 42px;
    line-height: 20px;
  }
  .post-status-but{
    font-size: 14px;
    color: #1D65A8;
    padding:10px 21px;
    border: 1px solid #eee;
  }
}
</style>
